import React, { Component } from 'react';

import { getClass } from '../../../utils/component-helpers';

import { authService } from '../../../services/auth';
import { errors } from '../../../services/errors';

import narrativLogoText from '../../../images/logos/narrativ_text.png';
import './change-password.scss';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.AuthService = authService;
    this.Errors = errors;

    this.state = {
      credentials: {
        username: '',
        old_password: '',
        new_password: '',
        repeat_new_password: '',
      },
      validationMessage: '',
    };

    this.updateField = this.updateField.bind(this);
  }

  updateField(name) {
    return event => {
      const { value } = event.target;

      this.setState(currentState => {
        currentState.credentials[name] = value;
        return currentState;
      });
    };
  }

  passwordsMatch() {
    const { credentials } = this.state;
    return (
      credentials.new_password === credentials.repeat_new_password &&
      credentials.new_password !== ''
    );
  }

  validCredentials(limited = false) {
    /*
     * Limited attribute - for limited validation, to determine
     * if the submit button should be greyed out
     */
    const { credentials } = this.state;
    const fields = Object.keys(credentials);

    for (let i = 0; i < fields.length; i++) {
      if (!credentials[fields[i]]) {
        if (limited) return false;
        this.setState({
          validationMessage: this.Errors.messages.credentials_empty,
        });
        return false;
      }
    }

    if (limited) return true;

    if (!this.passwordsMatch()) {
      this.setState({
        validationMessage: this.Errors.messages.password_not_match,
      });
      return false;
    }
    if (credentials.new_password.length < 8) {
      this.setState({
        validationMessage: this.Errors.messages.password_too_short,
      });
      return false;
    }
    if (credentials.new_password.length > 70) {
      this.setState({
        validationMessage: this.Errors.messages.password_too_long,
      });
      return false;
    }

    return true;
  }

  redirectAfterLogin() {
    /*
     * Redirect to setup if they had to change their temp password,
     * otherwise redirect to homepage
     */
    const { codes } = this.Errors;
    const params = new URLSearchParams(this.props.location.search);

    if (codes[parseInt(params.get('code'))] === 'tempPassword') {
      this.props.history.push('/account/setup');
    } else {
      this.props.history.push('/');
    }
  }

  handleError(error) {
    let message = '';
    const errorCode = error.code;

    switch (errorCode) {
      case 4001:
        message = this.Errors.messages.password_not_match;
        break;
      case 4002:
        message = this.Errors.messages.password_too_short;
        break;
      case 4003:
        message = this.Errors.messages.password_same;
        break;
      case 4301:
        message = this.Errors.messages.credentials_current_incorrect;
        break;
      default:
        message = error.message;
        break;
    }

    this.setState({ validationMessage: message });
  }

  updatePassword(event) {
    event.preventDefault();
    if (!this.validCredentials()) return;

    this.AuthService.changePassword(this.state.credentials)
      .then(() => {
        return this.AuthService.login({
          username: this.state.credentials.username,
          password: this.state.credentials.new_password,
        });
      })
      .then(
        () => this.redirectAfterLogin(),
        error => this.handleError(error),
      );
  }

  render() {
    const buttonEnabled = !this.validCredentials(true) ? 'disabled' : '';

    return (
      <div className="change-password">
        <div className="content-container">
          <div className="logo">
            <img
              src={narrativLogoText}
              title="Narrativ"
              alt="Narrativ is the first real-time exchange
							     for premium Publisher content."
            />
          </div>

          <form onSubmit={this.updatePassword.bind(this)} className="change-password-page">
            <div className="input-container">
              <label
                className={getClass({
                  'is-filled': this.state.credentials.username,
                })}
              >
                Username
              </label>
              <input
                className="username"
                label="Username"
                type="text"
                value={this.state.credentials.username}
                onChange={this.updateField('username')}
              />
            </div>

            <div className="input-container">
              <label
                className={getClass({
                  'is-filled': this.state.credentials.old_password,
                })}
              >
                Password
              </label>
              <input
                className="password"
                label="Password"
                type="password"
                value={this.state.credentials.old_password}
                onChange={this.updateField('old_password')}
              />
            </div>

            <div className="input-container">
              <label
                className={getClass({
                  'is-filled': this.state.credentials.new_password,
                })}
              >
                New Password
              </label>
              <input
                className="new-password"
                label="New Password"
                type="password"
                value={this.state.credentials.new_password}
                onChange={this.updateField('new_password')}
              />
            </div>

            <div className="input-container">
              <label
                className={getClass({
                  'is-filled': this.state.credentials.repeat_new_password,
                })}
              >
                Confirm New Password
              </label>
              <input
                className="confirm-new-password"
                label="Confirm New Password"
                type="password"
                value={this.state.credentials.repeat_new_password}
                onChange={this.updateField('repeat_new_password')}
              />

              <div className={getClass('strength-wrapper', { disabled: !this.passwordsMatch() })}>
                <div className="icon icon-small-check"></div>
              </div>
            </div>

            <p className="warning">{this.state.validationMessage}</p>

            <button className={`change-password-btn ${buttonEnabled}`}>Set new password</button>
          </form>
        </div>
      </div>
    );
  }
}

export default ChangePassword;
